import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalCompleteInformationPage } from './modal-complete-information.page';

const routes: Routes = [
  {
    path: '',
    component: ModalCompleteInformationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalCompleteInformationPageRoutingModule {}
